import React, { useState } from "react";
import { Box, Button, Card, CardContent, Chip, Container, Grid, Tab, Tabs, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import EstoreChrome from "../components/EstoreChrome";
import { brand } from "../data/estoreContent";
import { ESTORE_ROUTES, estoreProductUrl } from "../data/estorePaths";

const mockOrders = [
  { id: "ES-2401", date: "2026-04-01", total: 449, status: "Delivered" },
  { id: "ES-2404", date: "2026-04-04", total: 199, status: "Shipped" },
];

const mockSaved = [
  { id: 3, title: "Leather Tote", price: 210, image: "https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=200&h=200&fit=crop&q=80" },
  { id: 5, title: "Smart Watch", price: 279, image: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=200&h=200&fit=crop&q=80" },
];

function EstoreAccount() {
  const navigate = useNavigate();
  const [tab, setTab] = useState(0);

  return (
    <Box sx={{ mt: 7, minHeight: "100vh", bgcolor: brand.bg }}>
      <EstoreChrome title="Account" />
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Typography variant="h5" fontWeight={800} sx={{ mb: 2 }}>Welcome back</Typography>
        <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 3, borderBottom: 1, borderColor: "divider" }}>
          <Tab label="Orders" sx={{ textTransform: "none", fontWeight: 700 }} />
          <Tab label="Saved" sx={{ textTransform: "none", fontWeight: 700 }} />
        </Tabs>
        {tab === 0 && (
          <Grid container spacing={2}>
            {mockOrders.map((o) => (
              <Grid item xs={12} key={o.id}>
                <Card elevation={0} sx={{ border: `1px solid ${brand.stroke}`, borderRadius: 3 }}>
                  <CardContent sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 2 }}>
                    <Box>
                      <Typography fontWeight={800}>{o.id}</Typography>
                      <Typography variant="body2" sx={{ color: brand.muted }}>{o.date}</Typography>
                    </Box>
                    <Chip label={o.status} size="small" color={o.status === "Delivered" ? "success" : "primary"} />
                    <Typography fontWeight={800}>₹{o.total}</Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
        {tab === 1 && (
          <Grid container spacing={2}>
            {mockSaved.map((item) => (
              <Grid item xs={12} sm={6} key={item.id}>
                <Card
                  elevation={0}
                  onClick={() => navigate(estoreProductUrl(item.id))}
                  sx={{ border: `1px solid ${brand.stroke}`, borderRadius: 3, cursor: "pointer" }}
                >
                  <CardContent sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                    <Box component="img" src={item.image} alt="" sx={{ width: 72, height: 72, objectFit: "cover", borderRadius: 1 }} />
                    <Box>
                      <Typography fontWeight={800}>{item.title}</Typography>
                      <Typography variant="body2" sx={{ color: brand.muted }}>₹{item.price}</Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}
        <Button sx={{ mt: 3, textTransform: "none", fontWeight: 700 }} onClick={() => navigate(ESTORE_ROUTES.shop)}>
          Browse catalog
        </Button>
      </Container>
    </Box>
  );
}

export default EstoreAccount;
